import type { MasterSearchResultType } from './masterSearch';
import { maskEmailAddress, maskFreeText, maskPersonName } from './privacyMasking';

interface SearchResultIdentity {
  type: MasterSearchResultType;
  title: string;
  subtitle?: string;
}
export function maskMasterSearchResult(result: SearchResultIdentity): Pick<SearchResultIdentity, 'title' | 'subtitle'> {
  switch (result.type) {
    case 'customer':
    case 'traveler':
      return { title: maskPersonName(result.title), subtitle: result.subtitle ? maskEmailAddress(result.subtitle) : undefined };
    case 'company':
      return { title: 'Company hidden', subtitle: result.subtitle };
    case 'supplier':
      return { title: 'Supplier hidden', subtitle: 'Supplier details hidden' };
    case 'booking':
    case 'pnt':
      return { title: 'Booking identity hidden', subtitle: 'Booking locator hidden' };
    case 'pnr':
      return { title: 'Locator hidden', subtitle: 'Passenger identity hidden' };
    case 'invoice':
      return { title: 'Invoice reference hidden', subtitle: 'Amount hidden' };
    case 'trip':
      return { title: 'Trip hidden', subtitle: 'Trip details hidden' };
    case 'document':
      return { title: 'Document hidden', subtitle: result.subtitle ? 'Document details hidden' : undefined };
    case 'task':
      return { title: maskFreeText(result.title, 'Task details hidden'), subtitle: result.subtitle };
    case 'ticket': {
      const reference = result.title.match(/^#\d+/)?.[0];
      return { title: `${reference ? `${reference} ` : ''}Ticket subject hidden`, subtitle: result.subtitle };
    }
    default:
      return { title: result.title, subtitle: result.subtitle };
  }
}
